import { observer } from "mobx-react-lite";
import { useStore } from "../../../../../root-store-context";
import { Button, Card, Col, Row, Spin, Typography } from "antd";
import styles from "./RecipientItem.module.scss";
import { EditModal } from "./EditModal";
import { useState } from "react";
import { useCamIsMobile } from "hooks/useCamIsMobile";

const { Text } = Typography;

export const RecipientItemBody = observer((props: { guid: string }) => {
  const { applicationStore } = useStore();
  const [isOpenModalEdit, setIsOpenModalEdit] = useState<boolean>(false);
  const isMobile = useCamIsMobile();

  const data = applicationStore.mailJob.files?.find(
    (_) => _.guid === props.guid
  );

  return (
    <>
      <h3 style={{ marginTop: 0 }}>Account: {data?.fileInfo?.account}</h3>

      <Card style={{ maxWidth: isMobile ? "100%" : "66%" }}>
        <Spin spinning={false}>
          <Row gutter={[0, 12]}>
            <Col xs={24} sm={20}>
              <Typography className={styles.cardTypography}>
                <Text type="secondary">
                  <b>Name:</b>{" "}
                  {data?.fileInfo?.recipient?.rc_CustomFirstName !== ""
                    ? data?.fileInfo?.recipient?.rc_CustomFirstName
                    : data?.fileInfo?.recipient?.rc_FirstName}{" "}
                  {data?.fileInfo?.recipient?.rc_CustomLastName !== ""
                    ? data?.fileInfo?.recipient?.rc_CustomLastName
                    : data?.fileInfo?.recipient?.rc_LastName}
                </Text>
              </Typography>
              <Typography className={styles.cardTypography}>
                <Text type="secondary">
                  <b>Type:</b> {data?.fileInfo?.recipient?.contactType}
                </Text>
              </Typography>
              <Typography className={styles.cardTypography}>
                <Text type="secondary">
                  <b>Homeowner Preference:</b>{" "}
                  {data?.fileInfo?.recipient?.rc_SendMail ? "Email" : "Physical Print"}
                </Text>
              </Typography>
              <Typography className={styles.cardTypography}>
                {(data?.fileInfo?.recipient?.rc_CustomAddress !== undefined &&
                  data?.fileInfo?.recipient?.rc_CustomAddress !== "") ||
                data?.fileInfo?.recipient?.rc_Address !== "" ? (
                  <Text type="secondary">
                    <b>Address:</b>{" "}
                    {data?.fileInfo?.recipient?.rc_CustomAddress !== undefined &&
                    data?.fileInfo?.recipient?.rc_CustomAddress !== "" ? (
                      <span>{data?.fileInfo?.recipient?.rc_CustomAddress}</span>
                    ) : (
                      <span>{data?.fileInfo?.recipient?.rc_Address}</span>
                    )}
                  </Text>
                ) : null}
              </Typography>
              <Typography className={styles.cardTypography}>
                {(data?.fileInfo?.recipient?.rc_CustomAddress2 !== undefined &&
                  data?.fileInfo?.recipient?.rc_CustomAddress2 !== "") ||
                data?.fileInfo?.recipient?.rc_Address2 !== "" ? (
                  <Text type="secondary">
                    <b>Address 2:</b>{" "}
                    {data?.fileInfo?.recipient?.rc_CustomAddress2 !== undefined &&
                    data?.fileInfo?.recipient?.rc_CustomAddress2 !== "" ? (
                      <span>{data?.fileInfo?.recipient?.rc_CustomAddress2}</span>
                    ) : (
                      <span>{data?.fileInfo?.recipient?.rc_Address2}</span>
                    )}
                  </Text>
                ) : null}
              </Typography>
              <Typography className={styles.cardTypography}>
                {(data?.fileInfo?.recipient?.rc_CustomCity !== undefined &&
                  data?.fileInfo?.recipient?.rc_CustomCity !== "") ||
                data?.fileInfo?.recipient?.rc_City !== "" ? (
                  <Text type="secondary">
                    <b>City:</b>{" "}
                    {data?.fileInfo?.recipient?.rc_CustomCity !== undefined &&
                    data?.fileInfo?.recipient?.rc_CustomCity !== "" ? (
                      <span>{data?.fileInfo?.recipient?.rc_CustomCity}</span>
                    ) : (
                      <span>{data?.fileInfo?.recipient?.rc_City}</span>
                    )}
                  </Text>
                ) : null}
              </Typography>
              <Typography className={styles.cardTypography}>
                {(data?.fileInfo?.recipient?.rc_CustomState !== undefined &&
                  data?.fileInfo?.recipient?.rc_CustomState !== "") ||
                data?.fileInfo?.recipient?.rc_State !== "" ? (
                  <Text type="secondary">
                    <b>State:</b>{" "}
                    {data?.fileInfo?.recipient?.rc_CustomState !== undefined &&
                    data?.fileInfo?.recipient?.rc_CustomState !== "" ? (
                      <span>{data?.fileInfo?.recipient?.rc_CustomState}</span>
                    ) : (
                      <span>{data?.fileInfo?.recipient?.rc_State}</span>
                    )}
                  </Text>
                ) : null}
              </Typography>
              <Typography className={styles.cardTypography}>
                {(data?.fileInfo?.recipient?.rc_CustomZipcode !== undefined &&
                  data?.fileInfo?.recipient?.rc_CustomZipcode !== "") ||
                data?.fileInfo?.recipient?.rc_Zipcode !== "" ? (
                  <Text type="secondary">
                    <b>ZIP:</b>{" "}
                    {data?.fileInfo?.recipient?.rc_CustomZipcode !== undefined &&
                    data?.fileInfo?.recipient?.rc_CustomZipcode !== "" ? (
                      <span>{data?.fileInfo?.recipient?.rc_CustomZipcode}</span>
                    ) : (
                      <span>{data?.fileInfo?.recipient?.rc_Zipcode}</span>
                    )}
                  </Text>
                ) : null}
              </Typography>
            </Col>

            <Col
              xs={24}
              sm={4}
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: isMobile ? "flex-start" : "flex-end",
              }}
            >
              {data?.fileInfo?.recipient?.rc_BuilderAccount === true && (
                <Button
                  data-testid={`cam-edit-recipient-btn-${props.guid}`}
                  className="cam__button-secondary"
                  onClick={() => setIsOpenModalEdit(true)}
                >
                  Edit
                </Button>
              )}
            </Col>
          </Row>
        </Spin>
      </Card>

      <EditModal
        isOpenModal={isOpenModalEdit}
        dismissModal={() => setIsOpenModalEdit(false)}
        recipient={data?.fileInfo?.recipient}
        onSave={(recipient) => {
          if (data?.guid) {
            applicationStore.setSelectedFileData(data.guid, { recipient });
          }
          setIsOpenModalEdit(false);
        }}
      />
    </>
  );
});